import { render, staticRenderFns } from "./BoxTagging.vue?vue&type=template&id=2220b051&scoped=true"
import script from "./BoxTagging.vue?vue&type=script&lang=js"
export * from "./BoxTagging.vue?vue&type=script&lang=js"
import style0 from "./BoxTagging.vue?vue&type=style&index=0&id=2220b051&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2220b051",
  null
  
)

export default component.exports